import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { TranslateLoader } from '@ngx-translate/core';
declare let I18N_VERSION: string;

// By using the compile time constant I18N_VERSION, we make sure that each time a new release is created, the i18n file (e.g. de.json) has a different version, thus bypassing any caching. Note that this behavior is disabled in dev mode.
@Injectable({ providedIn: 'root' })
export class CustomTranslateHttpLoader implements TranslateLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    const path = `/assets/i18n/${lang}.json`;
    return this.http.get(environment.production ? `${path}?v=${I18N_VERSION}` : path);
  }
}
